module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/landing-prizes-bg-0e93282aa1ad18c28135c249dfdaf70b.png";